import { Box, Button, Flex, Modal, Text, ThemeIcon } from "@mantine/core";
import { IconRoute } from "@tabler/icons-react";

const BRAND_NAVY = "var(--mantine-color-primary-6)";
const BRAND_YELLOW = "#ffc300";

const MODAL_AMBIENT_BG = `
  radial-gradient(ellipse 95% 75% at 0% 0%, rgba(59, 130, 246, 0.2) 0%, transparent 52%),
  radial-gradient(ellipse 90% 70% at 100% 100%, rgba(37, 99, 235, 0.14) 0%, transparent 50%),
  linear-gradient(180deg, rgba(255, 255, 255, 0.03) 0%, transparent 35%)
`;

interface FlexDemoOptInModalProps {
  opened: boolean;
  skipping: boolean;
  onYes: () => void;
  onNo: () => void;
}

export default function FlexDemoOptInModal({ opened, skipping, onYes, onNo }: FlexDemoOptInModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={() => undefined}
      centered
      size="md"
      radius="lg"
      padding={0}
      withCloseButton={false}
      closeOnClickOutside={false}
      closeOnEscape={false}
      overlayProps={{ backgroundOpacity: 0.6, blur: 4 }}
      styles={{
        content: {
          overflow: "hidden",
          backgroundColor: BRAND_NAVY,
          backgroundImage: MODAL_AMBIENT_BG,
          border: "none",
        },
        body: {
          position: "relative",
          padding: "32px 28px 28px",
        },
      }}
    >
      <Flex direction="column" align="center" gap="lg">
        <ThemeIcon
          size={80}
          radius="xl"
          style={{
            backgroundColor: BRAND_YELLOW,
            border: "none",
          }}
        >
          <IconRoute size={40} color={BRAND_NAVY} stroke={1.5} />
        </ThemeIcon>

        <Box ta="center">
          <Text fw={700} fz={{ base: 22, sm: 26 }} c="white" lh={1.25}>
            Do you want to see a short demo?
          </Text>
          <Text fz="sm" c="rgba(255, 255, 255, 0.88)" mt="sm" maw={420} mx="auto" lh={1.55}>
            We&apos;ll walk you through finding a company, expressing interest, and opening a workspace.
          </Text>
        </Box>

        <Flex direction="column" gap="sm" w="100%">
          <Button
            fullWidth
            size="md"
            onClick={onYes}
            disabled={skipping}
            styles={{
              root: {
                backgroundColor: BRAND_YELLOW,
                color: BRAND_NAVY,
                fontWeight: 700,
                border: "none",
                "&:hover": {
                  backgroundColor: "#e6b000",
                },
              },
              label: {
                color: BRAND_NAVY,
              },
            }}
          >
            Yes, show the demo
          </Button>
          <Button
            fullWidth
            size="md"
            variant="outline"
            onClick={onNo}
            loading={skipping}
            styles={{
              root: {
                color: "white",
                borderColor: "rgba(255, 255, 255, 0.45)",
                fontWeight: 600,
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.08)",
                },
              },
              label: {
                color: "white",
              },
            }}
          >
            No, skip
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
}
